/* eslint-disable @typescript-eslint/naming-convention */
export const AppConstants = {
  DEFAULT_VALIDATOR: 'required',
  GA_CONSENT: 'ga_consent',
  STORAGE_PREFIX: 'secret_',
  USER_LANGUAGE: 'user_language',
  VALIDATORS_KEY: 'validators',
  UNKNOWN_ERROR: 'unknown_error'
};
